import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFlow } from '../../contexts/FlowContext';
import PhotoUploader, { FlowUploadHeader } from '../../components/PhotoUploader';
import { WebFlowLayout } from '../WebFlowLayout';
import { SessionAPI } from '../../utils/sessionApi';

const UPLOAD_COMPLETE_STATUSES = new Set([
  'uploaded',
  'photos_uploaded',
]);

export const UploadFlowScreen: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useFlow();
  const [header, setHeader] = useState<FlowUploadHeader>({
    title: 'Upload your photos',
  });

  const handleHeaderChange = useCallback((nextHeader: FlowUploadHeader) => {
    setHeader(nextHeader);
  }, []);

  useEffect(() => {
    if (!state.sessionId || !state.sessionKey) {
      return;
    }

    let cancelled = false;

    SessionAPI.validateSession(state.sessionId, state.sessionKey)
      .then((response) => {
        if (cancelled || !response.valid) {
          return;
        }

        const status = response.status?.trim().toLowerCase();
        if (status && UPLOAD_COMPLETE_STATUSES.has(status)) {
          navigate('/book', { replace: true });
        }
      })
      .catch(() => {
        // Fall through to the upload screen if resume check fails.
      });

    return () => {
      cancelled = true;
    };
  }, [navigate, state.sessionId, state.sessionKey]);

  if (!state.sessionId || !state.sessionKey) {
    return (
      <WebFlowLayout title="Upload your photos">
        <p>Your session is not ready yet. Please sign in again.</p>
      </WebFlowLayout>
    );
  }

  return (
    <WebFlowLayout
      title={header.title}
      subtitle={header.subtitle}
    >
      <PhotoUploader
        sessionId={state.sessionId}
        sessionKey={state.sessionKey}
        flowMode
        onFlowHeaderChange={handleHeaderChange}
        onFlowUploadComplete={() => navigate('/book', { replace: true })}
      />
    </WebFlowLayout>
  );
};
